module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-05-13 at 3.02.23 PM.e3176884.png";